import { Menu, MenuPopover } from "@/components/ui/menu";
import { CustomMenuItem, type MenuItemConfig } from "@/components/ui/menu-item";
import { updateSegment } from "@/store/share-of-voice/segment/segment-async.actions";
import useSegmentStore, {
  type Segment,
} from "@/store/share-of-voice/segment/segment.slice";
import {
  EyeIcon,
  EyeSlashIcon,
  MinusCircleIcon,
  PencilIcon,
} from "@phosphor-icons/react";
import { Fragment } from "react";

interface SegmentMenuProps {
  segment: Pick<Segment, "id" | "name" | "hexColor" | "isVisible">;
}

const SegmentMenu = ({ segment }: SegmentMenuProps) => {
  const onEditSegment = useSegmentStore((state) => state.onEditSegment);
  const setDeleteSegmentId = useSegmentStore(
    (state) => state.setDeleteSegmentId,
  );
  const setIsDeleteSegmentModalOpen = useSegmentStore(
    (state) => state.setIsDeleteSegmentModalOpen,
  );
  const setSegmentName = useSegmentStore((state) => state.setSegmentName);

  const onDeleteSegment = () => {
    setDeleteSegmentId(segment.id);
    setIsDeleteSegmentModalOpen(true);
    setSegmentName(segment.name);
  };

  const menuItems: MenuItemConfig[] = [
    {
      id: "edit-segment",
      icon: <PencilIcon className={"text-gray-600 mr-2"} />,
      label: "Edit segment",
      onClick: () =>
        onEditSegment({
          segmentId: segment.id,
          color: segment.hexColor,
          name: segment.name,
        }),
    },
    {
      id: "toggle-segment-visibility",
      icon: segment.isVisible ? (
        <EyeSlashIcon className={"text-gray-600 mr-2"} />
      ) : (
        <EyeIcon className={"text-gray-600 mr-2"} />
      ),
      label: segment.isVisible ? "Hide segment" : "Show segment",
      onClick: () => {
        void updateSegment(
          {
            id: segment.id,
            isVisible: !segment.isVisible,
          },
          {
            showSuccessToast: false,
          },
        );
      },
    },
    {
      id: "remove-segment",
      icon: <MinusCircleIcon className={"text-gray-600 mr-2"} />,
      label: "Remove segment",
      onClick: () => onDeleteSegment(),
    },
  ];

  return (
    <MenuPopover>
      <Menu>
        {menuItems.map((item) => (
          <Fragment key={String(item.label)}>
            <CustomMenuItem config={item} />
          </Fragment>
        ))}
      </Menu>
    </MenuPopover>
  );
};

export default SegmentMenu;
